package fr.frux.feature.treeadd

import fr.frux.shared.domain.repository.UserRepository

/** Au-delà, la confirmation ordinaire part : la célébration ne retient jamais le retour à la carte. */
internal const val FIRST_CONTRIBUTION_CHECK_TIMEOUT_MS = 3_000L

/**
 * Première contribution (spec onboarding de contribution §4), sans contrat API nouveau : juste
 * après la création, le profil public de la personne compte ses arbres visibles, et un seul veut
 * dire que c'est celui-ci. [currentUserId] lit la session (`SessionState.Authenticated.user.id`).
 * Sans session ou sans réponse, rien n'est affirmé : c'est la confirmation ordinaire.
 */
class FirstContributionCheck(
    private val userRepository: UserRepository,
    private val currentUserId: () -> Long?,
) {
    suspend fun isFirst(): Boolean {
        val id = currentUserId() ?: return false
        return userRepository.getUserProfile(id).getOrNull()?.treesCount == 1
    }
}
